/**
 * Legacy URLs: redirect into the invoices module.
 */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

const SupplierBillsRoutes = ({ match }) => (
  <Switch>
    <Route
      exact
      path={`${match.url}/view-all`}
      render={() => <Redirect to="/app/invoices/view-all" />}
    />
    <Route
      exact
      path={`${match.url}/create`}
      render={() => <Redirect to="/app/invoices/create-supplier-bill" />}
    />
    <Redirect to="/app/invoices/view-all" />
  </Switch>
);

export default SupplierBillsRoutes;
